import {useGetPatientDataQuery} from '../queries/useGetPatientDataQuery';

export const usePatientData = () => {
	const {data: patientData, isLoading, isError, refetch} = useGetPatientDataQuery();
	const data = patientData ? patientData.content[0] : undefined;

	return {
		data,
		isLoading,
		isError,
		refetch,
	};
};
